import React from 'react';

import classes from './index.module.scss';
import { serializeLexical } from './serialize';

import { Document as DocumentType } from '@/payload/payload-types';
import { cn } from '@shadcn/lib/utils';

const RichTextLexical: React.FC<{
	className?: string;
	content: DocumentType['documentContent'];
}> = ({ className, content }) => {
	if (!content) {
		return null;
	}

	return (
		<div className={[classes.richText, cn('break-words', className)].filter(Boolean).join(' ')}>
			{content &&
				!Array.isArray(content) &&
				typeof content === 'object' &&
				'root' in content &&
				serializeLexical({ nodes: content?.root?.children })}
		</div>
	);
};

export default RichTextLexical;
